const URL = 'wss://hkapiws.domidesk.com/WS';
// const URL = 'ws://47.239.159.228:8889/WS';
import store from '@/store'
export default class WebSocketService {
  constructor(options = {}) {
    this.url = URL;
    this.ws = null;
    this.reconnectInterval = options.reconnectInterval || 2000; // 重连间隔时间
    this.heartBeatInterval = options.heartBeatInterval || 10000; // 心跳检测间隔时间
    this.heartBeatTimer = null;
    this.reconnectTimer = null;
    this.isManualClose = false; // 是否为手动关闭连接

    // 回调函数，初始为空，在需要时动态赋值
    this.onMessageHandler = null;
    this.onOpenHandler = null;
    this.onSendErrHandler = null;
  }

  /**
   * 允许在实例创建后动态设置回调函数
   */
  setHandlers({ onMessage, onOpen, onSendError }) {
    if (onMessage) this.onMessageHandler = onMessage;
    if (onOpen) this.onOpenHandler = onOpen;
    if (onSendError) this.onSendErrHandler = onSendError;
  }

  connect() {
    if (this.ws) {
      return;
    }
    this.isManualClose = false;
    this.ws = new WebSocket(this.url);

    this.ws.onopen = () => {
      // console.log('WebSocket 连接成功');
      if (this.onOpenHandler) this.onOpenHandler();
      this.startHeartBeat();
    };

    this.ws.onmessage = (event) => {
      if (this.onMessageHandler) {
        this.onMessageHandler(event.data);
      }
    };

    this.ws.onerror = (error) => {
      // console.error('WebSocket 发生错误:', error);
      this.reconnect();
    };

    this.ws.onclose = () => {
      // console.log('WebSocket 连接关闭');
      if (!this.isManualClose) {
        this.reconnect();
      }
    };
  }

  send(message) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify(message));
    } else {
      if (this.onSendErrHandler) this.onSendErrHandler(message);
      console.error('WebSocket 未连接，无法发送消息');
    }
  }

  close() {
    this.isManualClose = true;
    this.stopHeartBeat();
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
  }

  reconnect() {
    if (this.reconnectTimer) {
      return;
    }
    console.log(`将在 ${this.reconnectInterval / 1000} 秒后尝试重连...`);
    this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null;
      this.ws = null;
      this.connect();
      console.log(`开始重连...`);
    }, this.reconnectInterval);
  }

  startHeartBeat() {
    this.stopHeartBeat();
    this.heartBeatTimer = setInterval(() => {
      this.send({ type: 'HEARTBEAT', userType: 2, token: store?.getters?.token, });
    }, this.heartBeatInterval);
  }

  stopHeartBeat() {
    if (this.heartBeatTimer) {
      clearInterval(this.heartBeatTimer);
      this.heartBeatTimer = null;
    }
  }
}
